module.exports = __webpack_public_path__ + "img/logotype.6809ac7.svg";